import { ReactNode } from 'react';
import { Container, CurrentChild, BarsProgress, ContentLabels } from './styles';

type ProgressBarProps = {
  children?: ReactNode[];
  currentStep: number;
  labels?: string[];

  actionStep: (key: number) => void;
  index: number;
};

export const ProgressBar: React.FC<ProgressBarProps> = ({
  currentStep,
  actionStep,
  labels = [],
  index,
}) => {
  return (
    <Container>
      <ContentLabels index={index} totalLabels={labels}>
        {labels?.map((item, index) => (
          <CurrentChild
            key={index}
            active={currentStep === index}
            onClick={() => {
              actionStep(index);
            }}
          >
            {labels && <p> {labels[index]} </p>}
          </CurrentChild>
        ))}
      </ContentLabels>

      <div className="contentBars">
        {labels?.map((item, index) => (
          <CurrentChild
            key={index}
            active={currentStep === index}
            onClick={() => actionStep(index)}
          >
            <BarsProgress active={currentStep === index} />
          </CurrentChild>
        ))}
      </div>
    </Container>
  );
};
